<template>
    <div id="feature_create">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="featureHeader" v-if="$route.params.id > 0">Update Feature</span>
                    <span class="page-title" id="featureHeader" v-else>Add Feature</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="FeatureList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content feature-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container add-feature-section-main form-custom-select" id="FeatureForm">
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div v-for="(feature,index) in assetFeatures" v-bind:key="index" class="form-row">
                                    <!-- <template v-if="feature"> -->
                                        <!-- No need as category not required -->
                                        <!-- <label class="control-label col-md-2 mt-4 pt-1">{{ feature[0].catName }}</label> -->
                                        <div class="col-md-10">
                                            <!-- <template  v-for="(ft,feInd) in feature" > -->
                                                <div class="form-row" v-bind:key="'row'+index">
                                                    <div class="col-md-2 form-group">
                                                        <label class="control-label require">Code:</label>
                                                        <input type="text" class="form-control" v-model="feature.code"  placeholder="Code">
                                                        <div class="field-error">{{ feature.codeError }}</div>
                                                    </div>
                                                    <div class="col-md-5 form-group">
                                                        <label class="control-label require">Name:</label>
                                                        <input type="text" class="form-control" v-model="feature.name"  placeholder="Name">
                                                        <div class="field-error">{{ feature.nameError }}</div>
                                                    </div>
                                                    <!-- No need as category not required -->
                                                    <!-- <div class="col-md-3 form-group">
                                                        <label class="control-label">Weight Front:</label>
                                                        <input type="text" class="form-control" v-model="ft.weightFront" placeholder="Weight Front" name="">
                                                        <div class="field-error">{{ ft.weight_front_error_msg }}</div>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label class="control-label col-sm-12">Weight Rear:</label>
                                                        <input type="text" class="form-control" v-model="ft.weightRear" placeholder="Weight Rear" name="featureCategory.weight_rear">
                                                        <div class="field-error">{{ ft.weight_rear_error_msg  }}</div>
                                                    </div> -->
                                                    <div class="col-md-1 form-group mt-4 pt-1">
                                                        <template v-if="index > 0">
                                                            <a href="javascript:void()" class="fp-remove mr-2" v-on:click.prevent="removeLine($event,index)"></a>
                                                        </template>
                                                        <template v-if="id = ''">
                                                            <a href="javascript:void()" class="fp-plus" v-on:click.prevent="addLine($event,feature,index)"></a>
                                                        </template>
                                                    </div>
                                                </div>
                                            <!-- </template> -->
                                        </div>
                                    <!-- </template> -->
                                </div>
                                <div class="field-error">{{ common_error_msg }}</div>
                                <div class="btn-groups">
                                    <button type="submit" id="createFeatureBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateFeature" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createFeatureBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateFeature" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueFeatureBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateFeature(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelFeatureBtn" class="btn btn-tertiary" v-on:click.prevent="FeatureList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    
    import {commonMixins} from '../mixins/commonMixins';
    
    
    
    export default {
        name: "FeatureCreate",
        metaInfo() {
            return {title: (this.$route.params.id > 0)? "Update Asset Feature | " +process.env.COPYRIGHT_NAME : "Create Asset Feature | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins],
        data: () => ({
            isEdit:false,
            permissions: [],
            cantAccessPage: "",
            assetFeatureCategoryAll:[],
            assetFeatures:[],
            loading:false,
            sectionratesArr: [],
            code: "",
            code_error_msg:"",
            name:"",
            name_error_msg:"",
            weight_front:"",
            weight_front_error_msg: "",
            weight_rear:"",
            weight_rear_error_msg: "",
            common_error_msg:"",
            id:""
        }),
        watch: {

            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'add_feature') {
                            self.cantAccessPage = true;

                        }
                    }
                }

            },

        },
        created: function() {

        },
        mounted: function() {
            var self = this;
            // self.statusValue = 1;
            self.getPermissions();
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3]) {
                self.id = segments[3];
                self.loadFeatures();
            }else{
                //self.AssetFeatureCategoryAll();
                self.$set(self.assetFeatures,0,{
                                                    id:"",
                                                    name:"",
                                                    code:"",
                                                    nameError:"",
                                                    codeError:""
                                                });
            }
        },
        methods: {

            addLine ($event, feature,index) {

                var featureLength = this.assetFeatures.length;

                if ( this.assetFeatures[index].code == "" || this.assetFeatures[index].code == null) {
                    this.assetFeatures[index].codeError = "Code Required.";
                }

                if ( this.assetFeatures[index].name == "" || this.assetFeatures[index].name == null) {
                    this.assetFeatures[index].nameError = "Name Required.";
                }

                if( this.assetFeatures[index].code != "" && this.assetFeatures[index].name != "" ){
                    this.assetFeatures[index].codeError = "";
                    this.assetFeatures[index].nameError = "";
                    this.$set(this.assetFeatures,this.assetFeatures.length,{id:"",name:'',code:'',nameError:"",codeError:""});
                }
            },

            removeLine ($event,index) {

                if(this.assetFeatures.length > 1 && index >0)
                {
                    this.$delete(this.assetFeatures,index);
                }

            },
            FeatureList() {
                var self = this;
                self.$router.push("/feature/list");
            },
            

            AssetFeatureCategoryAll(){

                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/assetfeaturecategory/search-category",
                    type: "POST",
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    dataType: "json",
                    success: function (data) {

                        if (data.status == "success") {
                            if ( data.content.length > 0 ) {
                                for( var i=0; i<data.content.length;i++) {

                                    self.$set(self.assetFeatures,data.content[i].id,[]);
                                    // self.$set(self.assetFeatures[data.content[i].id],0,{id:"",catId:data.content[i].id,catName:data.content[i].name,name:'',code:'',wf:'',wr:''})
                                    self.$set(self.assetFeatures[data.content[i].id],0,{
                                        id:"",catId:data.content[i].id,
                                        catName:data.content[i].name,name:"",
                                        code:"",weightFront:"",weightRear:"",
                                        nameError:"",codeError:""
                                    })
                                    // self.$set(self.assetFeatures[data.content[i].id],1,{id:"",catId:data.content[i].id,catName:data.content[i].name,name:'',code:'',wf:'',wr:''})
                                }
                            }
                            self.assetFeatureCategoryAll = data.content;
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.generateStatusCodeMessage(jqXHR,true,'feature-cate-search')
                    }
                });

            },

            
            CreateFeature(flag) {
                var self = this;
                var error = false;
                self.common_error_msg = "";
                var featuresArray = []; //Array containing Categories with Features

                 for(var i=0;i<self.assetFeatures.length;i++){

                    if( self.assetFeatures[i] != undefined){
                         var featureItemsArray = [];   // Array containing single or multiple features under single category
                         

                        if(self.assetFeatures[i].nameError != ""){
                            self.assetFeatures[i].nameError = "";
                        }
                        if(self.assetFeatures[i].codeError != ""){
                            self.assetFeatures[i].codeError = "";
                        }

                        if(self.assetFeatures[i].name.length !== 0 || self.assetFeatures[i].code.length  !== 0)
                        {
                                if(self.assetFeatures[i].name.length === 0 )
                                {
                                    self.assetFeatures[i].nameError = "Name Required";
                                    error = true;
                                }
                                if(self.assetFeatures[i].code.length === 0 )
                                {
                                    self.assetFeatures[i].codeError = "Code Required";
                                    error = true;
                                }
                        }
                    }
                }
                
                /*if any feature is not filled */
                // if(featuresArray.length < 1){
                //         self.common_error_msg = "Please fill any Feature."
                //         error = true;
                // }

                if (!error) {
                    self.loading = true;
                    
                    if ( self.id != "" )
                    {
                        $("#createFeatureBtn").val("Updating ...");
                        $("#createFeatureBtn").prop("disabled", true);
                        $("#cancelFeatureBtn").prop("disabled",true);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueFeatureBtn").val("Saving ...");
                            $("#createFeatureBtn").prop("disabled", true);
                            $("#createAndContinueFeatureBtn").prop("disabled", true);
                            $("#cancelFeatureBtn").prop("disabled",true);

                        } else{

                            $("#createFeatureBtn").val("Saving ...");
                            $("#createFeatureBtn").prop("disabled", true);
                            $("#createAndContinueFeatureBtn").prop("disabled", true);
                            $("#cancelFeatureBtn").prop("disabled",true);
                        }
                    }

                    var fields = $("#FeatureForm").serializeArray();

                    fields.push({ name: "id", value: self.id });
                    fields.push({ name: "standard_item", value: JSON.stringify(self.assetFeatures) });

                    $.ajax({
                        url: process.env.ROOT_API + "/feature/create",
                        type: "POST",
                        data: fields,
                        headers: this.ajxHeaders,

                        dataType: "json",
                        success: function (data) {
                            self.loading = false;
                            if (self.id != "" )
                            {
                                $("#createFeatureBtn").val("Update");
                                $("#createFeatureBtn").prop("disabled", false);
                                $("#cancelFeatureBtn").prop("disabled",false);
                            } else {
                                if (flag == "Save and Continue") {

                                    $("#createAndContinueFeatureBtn").val("Save and Continue");
                                    $("#createFeatureBtn").prop("disabled", false);
                                    $("#createAndContinueFeatureBtn").prop("disabled", false);
                                    $("#cancelFeatureBtn").prop("disabled",false);

                                } else{

                                    $("#createFeatureBtn").val("Save");
                                    $("#createFeatureBtn").prop("disabled", false);
                                    $("#createAndContinueFeatureBtn").prop("disabled", false);
                                    $("#cancelFeatureBtn").prop("disabled",false);

                                }
                            }
                            if (data.status == "success") {

                                if (flag == "Save and Continue") {

                                    $("#FeatureForm").trigger("reset");

                                    self.assetFeatures=[];
                                    //self.AssetFeatureCategoryAll();

                                } else{
                                    self.$router.push("/feature/list");
                                }

                            } else {
                                if (data.content.length > 0) {
                                    var err = "";
                                    for (var i = 0; i < data.content.length; i++) {
                                        err += data.content[i] + "<br>";
                                    }
                                    $("#errorMsg").html(err);
                                    $(".alert-warning").toggleClass("show");
                                    setTimeout(function () {
                                        $(".alert-warning").removeClass("show");
                                        $(".alert-warning").addClass("hide");
                                    }, 10000);
                                }
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            if (self.id != "")
                            {
                                $("#createFeatureBtn").val("Update");
                                $("#createFeatureBtn").prop("disabled", false);
                                $("#cancelFeatureBtn").prop("disabled",false);
                            } else {
                                if (flag == "Save and Continue") {

                                    $("#VehicleGroupForm").trigger("reset");
                                    $("#createAndContinueFeatureBtn").val("Save and Continue");
                                    $("#createFeatureBtn").prop("disabled", false);
                                    $("#createAndContinueFeatureBtn").prop("disabled", false);
                                    $("#cancelFeatureBtn").prop("disabled",false);

                                } else{

                                    $("#createFeatureBtn").val("Save");
                                    $("#createFeatureBtn").prop("disabled", false);
                                    $("#createAndContinueFeatureBtn").prop("disabled", false);
                                    $("#cancelFeatureBtn").prop("disabled",false);

                                }
                            }
                            self.generateStatusCodeMessage(jqXHR,true,'feature-create')
                        }
                    });
                }
                  
            },

            loadFeatures() {

                var self = this;
                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/features/" + self.id,
                    type: "GET",
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        console.log(data);
                        self.loading = false;
                        if (data.status == "success") {
                            self.isEdit = true;
                            self.$set(self.assetFeatures,0,[]);
                            // self.$set(self.assetFeatures[data.content[i].id],0,{id:"",catId:data.content[i].id,catName:data.content[i].name,name:'',code:'',wf:'',wr:''})
                            self.$set(self.assetFeatures,0,{
                                                            id:data.content.id,
                                                            name:data.content.name,
                                                            code:data.content.code,
                                                            nameError:"",
                                                            codeError:""
                            })
                            // self.$set(self.assetFeatures[data.content[i].id],1,{id:"",catId:data.content[i].id,catName:data.content[i].name,name:'',code:'',wf:'',wr:''})
                            
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'feature-by-id')
                    }
                });
            },


            titleCase(str) {
                if (str == null){
                    return;
                } else{
                    var value = str.toString()
                    return value.charAt(0).toUpperCase() + value.slice(1)
                }
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/FeatureCreate.vue